import React from "react";
import { RouteObject } from "react-router-dom";
import MainLayout from "../MainLayout";


const MainRoutes: RouteObject[] = [
    {
        path: "",
        element: <MainLayout />,
        children: [
            // { path: "/", element: <KokobeoHomepage /> },
        ],
    },
];
export default MainRoutes;